import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { CheckCircle2, ArrowRight, Store, Package, Share2 } from 'lucide-react'
import { Button } from '../components/ui/Button'
import { Card, CardContent } from '../components/ui/Card'

const nextSteps = [
  { icon: Store, text: 'Lengkapi profil usaha Anda' },
  { icon: Package, text: 'Tambahkan produk pertama' },
  { icon: Share2, text: 'Bagikan link katalog ke pelanggan' },
]

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export default function RegisterSuccess() {
  useEffect(() => {
    document.title = 'Pendaftaran Berhasil | UMKM Indonesia'

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'sign_up', { method: 'email' })
    }

    return () => {
      document.title = 'UMKM Indonesia - Katalog Pro'
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gray-50">
      <Card className="w-full max-w-lg shadow-lg border-0">
        <CardContent className="p-8 md:p-10 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-indigo-100 flex items-center justify-center">
            <CheckCircle2 className="w-9 h-9 text-indigo-600" />
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Selamat! Akun Anda Berhasil Dibuat
          </h1>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Anda siap membuat katalog online usaha. Mulai lengkapi profil dan tambahkan produk pertama Anda.
          </p>

          <ul className="text-left space-y-3 mb-8 bg-indigo-50/60 rounded-xl p-5">
            {nextSteps.map((step, idx) => (
              <li key={idx} className="flex items-center gap-3 text-sm text-gray-700">
                <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <step.icon className="w-4 h-4 text-indigo-600" />
                </div>
                {step.text}
              </li>
            ))}
          </ul>

          <Link to="/dashboard" className="block">
            <Button size="lg" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">
              Masuk ke Dashboard
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>

          <p className="mt-4 text-xs text-gray-500">
            Gratis untuk memulai • Tanpa biaya tersembunyi
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
